import { ListViewTableHeaderData } from './types';

export const FBP_BPS_PRECISION = 4;

export const flexibleBenefitsInitialState = {
  name: '',
  displayName: '',
  description: '',
  category: '',
  isActive: true,
  componentType: 'COMPONENT_TYPE_FBP',
  source: 'FBP',

  showInGrossSalary: true,
  nonCashBenefit: false,

  declarationMethod: 'enable-declaration',
  benefitAmountType: 'enable-declaration',

  declaration_settings: {
    declaration_enabled: 'true',
  },

  benefit_amount_settings: {
    type: 'RANGE',
    unit: 'ACTUAL_AMOUNT',
    value: '',
    options: [],
  },

  includeInPfWages: false,

  includeInPtWages: false,

  includeInEsiWages: false,

  includeInLwfWages: false,

  tax_behaviour: {
    tax_exempt_in_old_regime: false,
    tax_exempt_in_new_regime: false,
    tax_exemption_section: '',
    tax_deduction_behaviour: 'instant',
  },

  arrear_behaviour: {
    consider_in_arrear: false,
    allow_negative: false,
  },

  showZero: true,
  visibleToEmployee: false,

  proration_behaviour: {
    support_proration: false,
  },

  declarationEnabled: 'true',

  hold_settings: {
    hold_unclaimed_amount: 'false',
  },
};

export const FBP_STATUS_FILTERS = {
  all: '',
  active: 'SALARY_COMPONENT_STATUS_ACTIVE',
  disabled: 'SALARY_COMPONENT_STATUS_INACTIVE',
} as Record<string, string>;

export const FlexibleBenefitsListViewHeaders: ListViewTableHeaderData[] = [
  { name: 'Component name' },
  {
    name: 'Display name',
    tooltipText: "The name that will appear in employee's payslip and Salary Register",
  },
  { name: 'Benefit value' },

  { name: 'Status' },
];
